import { map } from 'rxjs/operators';
import { parseDate } from '../utils/date-utils';
import { BaseService } from './base-service';
export class ProductService {
    static getProducts(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return BaseService.getPaginated(`products?filter=${qs}`, pageNumber)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.product.createdOn = parseDate(x.product.createdOn);
                x.product.updatedOn = parseDate(x.product.updatedOn);
            });
            return w;
        }));
    }
    static fetchProduct(oid) {
        return BaseService.get(`products/${oid}`).pipe(map(x => {
            x.payload.createdOn = parseDate(x.payload.createdOn);
            x.payload.updatedOn = parseDate(x.payload.updatedOn);
            return x;
        }));
    }
    static saveProduct(dto) {
        return BaseService.save(`products`, dto);
    }
    static deleteProduct(oid) {
        return BaseService.delete(`products/${oid}`);
    }
    // ----------------------------------------------------------------------
    // Search Dropdown
    // ----------------------------------------------------------------------
    static searchProductCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return BaseService.get(`products-combo/${selfId}?search=${qs}`);
    }
}
